<div class="currency-indicator" [class.currency-indicator--black]="variant() === 'black'">
  <div class="currency-indicator__flag" [ngClass]="flagClass()" [attr.aria-label]="effectiveCountryCode() + ' flag'"></div>
  @if (showText()) {
    <div class="currency-indicator__text">
      <p class="currency-indicator__currency-code">{{ currencyCode() }}</p>
    </div>
  }
</div>
